export const state = {
    isLoading: false,
    isShow: false,
    isPrint: false,
    isPreview: false,
    isFirstLoaded: false,
    appVersion: 0.1,

    ownPage: {
        id: "1589379301391164",
        project_name: "L'Oréal Paris"
    },

    myApps: [
        {
            id : "1589379301391164",
            project_name: "L'Oréal Paris",
            favourite: true,
        }
    ],

    competitorBenchmark: {
        competitor_ids: ["1589379301391164", "285372561489192", "509403522505512"],
        competitors: [],
        competitor_avg: {
            fans: 0,
            engagement: 0,
            posts: 0
        },
    },

    pages: [],

    ownPageData: {
        // Content Performance
        post_by_photo: 0,
        post_by_video: 0,
        reach_by_photo: 0,
        reach_by_video: 0,
        engagement_by_photo: 0,
        engagement_by_video: 0,

        post: {
            value: 0,
            percent: 0,
        },
        avg_reach_per_post: {
            value: 0,
            percent: 0,
        },
        avg_engagement_rate: {
            value: 0,
            percent: 0,
        },
        post_engagement: {
            value: 0,
            percent: 0,
        },
        post_reach: {
            value: 0,
            percent: 0,
        },
        video_view_time: {
            value: 0,
            percent: 0,
        },
        three_second_video_view: {
            value: 0,
            percent: 0,
        },

        // Social Media
        engagement: {
            value: 0,
            percent: 0,
        },
        engagement_rate: {
            value: 0,
            percent: 0,
        },
        comments: {
            value: 0,
            percent: 0,
        },
        share: {
            value: 0,
            percent: 0,
        },
        reactions: {
            value: 0,
            percent: 0,
        },
        messages: {
            value: 0,
            percent: 0,
        },
        reach: {
            value: 0,
            percent: 0,
        },
        impression: {
            value: 0,
            percent: 0,
        },
        paid_reach: {
            value: 0,
            percent: 0,
        },
        organic_reach: {
            value: 0,
            percent: 0,
        },
        avg_response_time: {
            value: 0,
            percent: 0,
        },
        budget_spend: {
            value: 0,
            percent: 0,
        },
        fans_growth: {
            value: 0,
            diff: 0,
        },
        cpm: {
            value: 0,
            diff: 0,
        },
        cpa: {
            value: 0,
            diff: 0,
        },
        ctr: {
            value: 0,
            diff: 0,
        },

        posts: [],
    },


    dateRangeData: {
        minDate: '2019-05-02 04:00:00',
        maxDate: '2100-12-31 23:00:00',
        opens: 'right',
    },

    dateTime: {
        startDate: 1577122200000,
        endDate: 1577208599999,
    }
};
